const Keycode = {
  ARROW_DOWN: 40,
  ARROW_UP: 38,
  ARROW_RIGHT: 39,
  ARROW_LEFT: 37,
  ENTER: 13,
  ESC: 27,
  SPACE: 32,
  HOME: 36,
  END: 35,
  TAB: 9,
};

const TOAST_ERROR_TYPE = 'error';
const TOAST_SUCCESS_TYPE = 'success';
let timeout = null;

function showToast(message, type, container) {
  container = container || '.toast-container';
  let $toast = $(container + ' .toast');
  if (!$toast.length) {
    $(container).append('<div class="toast"></div>');
    $toast = $(container + ' .toast');
  }
  if (timeout) {
    clearTimeout(timeout);
    $toast.removeClass('error');
    $toast.removeClass('success');
    timeout = null;
  }
  if (type === TOAST_ERROR_TYPE) {
    $toast.text(message).addClass('active').addClass('error');
    timeout = setTimeout(function () {
      $toast.removeClass('active');
      $toast.removeClass('error');
      $toast.text('');
      timeout = null;
    }, 7000);
  } else {
    // SUCCESS TYPE
    $toast.text(message).addClass('active').addClass('success');
    timeout = setTimeout(function () {
      $toast.removeClass('active');
      $toast.removeClass('success');
      $toast.text('');
      timeout = null;
    }, 7000);
  }
}

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

const checkForUTMParams = (paramName) => {
  if (window.location.search) {
    let query = window.location.search;
    let queries = query.length ? query.substring(1).split('&') : [];
    if (queries.length) {
      queries = queries.filter((el) => el.includes(`utm_${paramName}`));
      return queries[0].split('=')[1];
    } else return 'organic';
  } else return 'organic';
};
function styleCountries() {
  $('.countryAPI').each(function () {
    var $this = $(this),
      numberOfOptions = $(this).children('option').length;
    $this.addClass('select-hidden');
    $this.wrap('<div class="select"></div>');
    if ($this.hasClass('countryAPI')) {
      $this.after('<input class="select-styled"></input>');
      var $styledSelect = $this.next('input.select-styled');
      $styledSelect.attr('placeholder', 'Select country of residence');
      $styledSelect.attr('autocomplete', 'off');
    } else {
      $this.after('<div class="select-styled"></div>');
      var $styledSelect = $this.next('div.select-styled');
      $styledSelect.text($this.children('option').eq(0).text());
    }
    var $list = $('<ul />', { class: 'select-options' }).insertAfter(
      $styledSelect
    );
    if ($this.hasClass('countryAPI')) {
      for (var i = 1; i < numberOfOptions; i++) {
        let flag = $this.children('option').eq(i).attr('flag');
        $(
          '<li tabindex="-1" rel="' +
            $this.children('option').eq(i).val() +
            '""><img src=https://content.coinis.com' +
            flag +
            ' />' +
            $this.children('option').eq(i).text() +
            '</li>'
        ).appendTo($list);
      }
      $('<li />', {
        text: 'No matching results.',
        rel: '404',
      })
        .appendTo($list)
        .hide();
      $list.find("[rel='404']").css('pointer-events', 'none');
    } else {
      for (var i = 0; i < numberOfOptions; i++) {
        $('<li />', {
          text: $this.children('option').eq(i).text(),
          rel: $this.children('option').eq(i).val(),
        }).appendTo($list);
      }
    }

    var $listItems = $list.children('li');
    if ($this.hasClass('countryAPI')) {
      $styledSelect.on('keyup', function (el) {
        $list.show();

        $(this).css('color', '#000');
        let value = el.target.value.toLowerCase();
        var regex = new RegExp('^' + value, 'i');
        if (value == '') {
          $listItems.show();
          $(this).find("[rel='404']").hide();
        } else {
          $listItems.each(function () {
            let input = $(this).text();
            if (input.match(regex)) {
              $(this).show();
            } else {
              $(this).hide();
            }
          });
        }

        if ($list.children('li:hidden').length == numberOfOptions) {
          $list.find("[rel='404']").show();
        } else {
          $list.find("[rel='404']").hide();
        }

        const availableItems = Array.from($list.children('li:not(:hidden)'));

        if (event.keyCode === Keycode.ARROW_DOWN) {
          $list.show();
          availableItems[0].focus();
        }

        if (event.keyCode === Keycode.ARROW_UP) {
          $list.show();
          availableItems[availableItems.length - 1].focus();
        }

        if (event.keyCode === Keycode.ESC) {
          $list.hide();
          $styledSelect.focus();
        }

        if (event.keyCode === Keycode.TAB) {
          $list.hide();
        }
      });

      for (const item of $listItems) {
        item.addEventListener('keydown', function () {
          const availableItems = Array.from($list.children('li:not(:hidden)'));
          const id = availableItems.indexOf(item);

          if (event.keyCode === Keycode.ARROW_DOWN) {
            event.preventDefault();
            if (id === availableItems.length - 1) {
              availableItems[0].focus();
            } else {
              availableItems[id + 1].focus();
            }
          }

          if (event.keyCode === Keycode.ARROW_UP) {
            event.preventDefault();
            if (id === 0) {
              availableItems[availableItems.length - 1].focus();
            } else {
              availableItems[id - 1].focus();
            }
          }

          if (
            event.keyCode === Keycode.ENTER ||
            event.keyCode === Keycode.SPACE
          ) {
            event.preventDefault();
            $styledSelect.css('color', '#000');
            $styledSelect.val($(this).text()).removeClass('active');

            $this.val($(this).attr('rel'));
            $this.val($(this).attr('rel')).trigger('change');
            $list.hide();
          }

          if (event.keyCode === Keycode.ESC) {
            $list.hide();
            $styledSelect.focus();
          }

          if (event.keyCode === Keycode.TAB) {
            $list.hide();
          }
        });
      }
    }
    $styledSelect.click(function (e) {
      e.stopPropagation();
      ($this.hasClass('countryAPI')
        ? $('input.select-styled.active')
        : $('div.select-styled.active')
      )
        .not(this)
        .each(function () {
          $(this).removeClass('active').next('ul.select-options').hide();
        });
      $(this).toggleClass('active').next('ul.select-options').toggle();

      $list.show();

      $(this).css('color', '#000');
      let value = e.target.value.toLowerCase();
      var regex = new RegExp('^' + value, 'i');
      if (value == '') {
        $listItems.show();
        $(this).find("[rel='404']").hide();
      } else {
        $listItems.each(function () {
          let input = $(this).text();
          if (input.match(regex)) {
            $(this).show();
          } else {
            $(this).hide();
          }
        });
      }

      if ($list.children('li:hidden').length == numberOfOptions) {
        $list.find("[rel='404']").show();
      } else {
        $list.find("[rel='404']").hide();
      }
    });

    $listItems.click(function (e) {
      $styledSelect.css('color', '#000');
      e.stopPropagation();
      if ($this.hasClass('countryAPI')) {
        $styledSelect.val($(this).text()).removeClass('active');
      } else {
        $styledSelect.text($(this).text()).removeClass('active');
      }
      $this.val($(this).attr('rel'));
      $this.val($(this).attr('rel')).trigger('change');
      $list.hide();
    });
    $(document).click(function () {
      $styledSelect.removeClass('active');
      $list.hide();
    });
  });
}

const makeStyledCategory = () => {
  $styledSelect = $('.select-styled.category');
  $list = $('.select-options.category');
  $listItems = $list.children('li');

  $styledSelect.on('keyup', function (el) {
    $list.show();
    $(this).css('color', '#000');
    let value = el.target.value.toLowerCase().trim();
    var regex = new RegExp('^' + escapeRegExp(value), 'i');

    if (value == '') {
      $listItems.show();
      $(this).find("[rel='404']").hide();
    } else {
      $listItems.each(function () {
        let input = $(this).text().toLowerCase().trim();

        if (input.match(regex)) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
    }

    numberOfOptions = $list.siblings().children('option').length;

    if ($list.children('li:hidden').length == numberOfOptions) {
      $list.find("[rel='404']").show();
    } else {
      $list.find("[rel='404']").hide();
    }

    const availableItems = Array.from($list.children('li:not(:hidden)'));

    if (event.keyCode === Keycode.ARROW_DOWN) {
      $list.show();
      availableItems[0].focus();
    }

    if (event.keyCode === Keycode.ARROW_UP) {
      $list.show();
      availableItems[availableItems.length - 1].focus();
    }

    if (event.keyCode === Keycode.ESC) {
      $list.hide();
      $styledSelect.focus();
    }

    if (event.keyCode === Keycode.TAB) {
      $list.hide();
    }
  });

  for (const item of $listItems) {
    item.addEventListener('keydown', function () {
      const availableItems = Array.from($list.children('li:not(:hidden)'));
      const id = availableItems.indexOf(item);

      if (event.keyCode === Keycode.ARROW_DOWN) {
        event.preventDefault();
        if (id === availableItems.length - 1) {
          availableItems[0].focus();
        } else {
          availableItems[id + 1].focus();
        }
      }

      if (event.keyCode === Keycode.ARROW_UP) {
        event.preventDefault();
        if (id === 0) {
          availableItems[availableItems.length - 1].focus();
        } else {
          availableItems[id - 1].focus();
        }
      }

      if (event.keyCode === Keycode.ESC) {
        $list.hide();
        $styledSelect.focus();
      }

      if (event.keyCode === Keycode.TAB) {
        $list.hide();
      }

      if (event.keyCode === Keycode.ENTER || event.keyCode === Keycode.SPACE) {
        event.preventDefault();
        $styledSelect.css('color', '#000');

        if ($(event.target).hasClass('.category')) {
          $styledSelect.val($(this).text()).removeClass('active');
        } else {
          $styledSelect.text($(this).text()).removeClass('active');
        }

        $customSelect.val($(this).attr('rel')).trigger('change');
        $styledSelect.val($(this).attr('rel'));
        $list.hide();
      }
    });
  }

  $styledSelect.click(function (e) {
    e.stopPropagation();
    // (e.hasClass("countryAPI")
    //   ? $("input.select-styled.category.active")
    //   : $("div.select-styled.category.active")
    // )
    //   .not(this)
    //   .each(function () {
    //     $(this).removeClass("active").next("ul.select-options").hide();
    //   });
    // $(this).toggleClass('active').next('ul.select-options').toggle();

    $list.show();
    $(this).css('color', '#000');
    let value = e.target.value.toLowerCase().trim();
    var regex = new RegExp('^' + escapeRegExp(value), 'i');

    if (value == '') {
      $listItems.show();
      $(this).find("[rel='404']").hide();
    } else {
      $listItems.each(function () {
        let input = $(this).text().toLowerCase().trim();

        if (input.match(regex)) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
    }

    numberOfOptions = $list.siblings().children('option').length;

    if ($list.children('li:hidden').length == numberOfOptions) {
      $list.find("[rel='404']").show();
    } else {
      $list.find("[rel='404']").hide();
    }
  });
  $customSelect = $('.customSelect');
  $listItems.click(function (e) {
    $styledSelect.css('color', '#000');
    e.stopPropagation();

    if ($(e.target).hasClass('.category')) {
      $styledSelect.val($(this).text()).removeClass('active');
    } else {
      $styledSelect.text($(this).text()).removeClass('active');
    }

    // $customSelect.val($(this).attr("rel"));
    $customSelect.val($(this).attr('rel')).trigger('change');
    $styledSelect.val($(this).attr('rel'));
    $list.hide();
  });
  $(document).click(function () {
    $styledSelect.removeClass('active');
    $list.hide();
  });
};

$(document).ready(function () {
  styleCountries();
  makeStyledCategory();
  const $sendButton = $('#send');

  const $nameField = $('#name');
  const $emailField = $('#email');
  const $websiteField = $('#website');
  const $categoryField = $('#category');
  // const $countryField = $("#country");
  const $revenueField = $('#revenue');
  const $descriptionField = $('#description');
  const $messageField = $('#message');

  $sendButton.click((event) => {
    event.preventDefault();
    const nameExists = $nameField.length > 0;
    const name = $nameField.val();
    const email = $emailField.val();
    const country = $('#country option:selected').attr('country_name');
    const category = $categoryField.val();
    const revenue = $revenueField.val();
    const description = $descriptionField.val();
    const message = $messageField.val();
    const website = $websiteField.val();

    if (
      (nameExists && !name) ||
      !email ||
      !website ||
      !category ||
      !country ||
      !revenue ||
      !description ||
      !message
    ) {
      showToast('You must fill all fields', TOAST_ERROR_TYPE);
      return;
    }

    $sendButton.attr('disabled', true);
    $sendButton.text('Sending...');

    $.ajax({
      type: 'POST',
      url: '/api/contact',
      data: JSON.stringify({
        name: name,
        email: email,
        website: website,
        category: category,
        country: country,
        revenue: revenue,
        description: description,
        message: message,
        utmSource: checkForUTMParams('source'),
        utmCampaign: checkForUTMParams('campaign'),
        utmMedium: checkForUTMParams('medium'),
      }),
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      success: async function (data) {
        $sendButton.attr('disabled', false);
        $sendButton.text('Send');
        window.location.href = '/thank-you';
      },
      error: function (xhr, status, error) {
        showToast(
          (xhr.responseJSON && xhr.responseJSON.message) ||
            'Something went wrong',
          TOAST_ERROR_TYPE
        );

        $sendButton.attr('disabled', false);
        $sendButton.text('Send');
      },
    });
  });
});
